import { Configuration, LogLevel } from "@azure/msal-browser";
import { config } from "../services/Constants";

const azureActiveDirectoryAppClientId: any = config.aadClientID;
const tenantId: any = config.tenantID;
//const redirectUri: any = config.redirectUri;

export const API_SCOPES = [
  "api://fdc9c7eb-6429-4eec-a9b9-eb67d61aebfa/access_as_user",
];

export const loginRequest = { scopes: API_SCOPES };

export const MSAL_CONFIG: Configuration = {
  auth: {
    clientId: azureActiveDirectoryAppClientId,
    authority: `https://login.microsoftonline.com/${tenantId}`, // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    //redirectUri: redirectUri
  },
  cache: {
    // localStorage (not sessionStorage) so the signed-in account is shared
    // across tabs — otherwise every new tab lands on the login page.
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            //console.info(message);
            return;
          case LogLevel.Verbose:
            //console.debug(message);
            return;
          case LogLevel.Warning:
            //console.warn(message);
            return;
        }
      },
    },
  },
};